export const getFieldName = (stepName, field) => `${stepName}.values.${field}`;

export const convertDropdownValue = (str) => {
    const intValue = parseInt(str, 10);
    if (Number.isNaN(intValue)) return '';
    return intValue;
};
